import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { TeamGoalStats } from "@data-types/sport-stats/SportStatsTypes";
import { Team, Tournament } from "@gp/models";
import TeamIcon from "@components/icons/TeamIcon";
import { TeamStats } from "./TeamStats";

export const TeamSection = ({
	teamData,
	mainTeam,
	opponentTeam,
	label,
	tournament,
	className,
}: {
	teamData: TeamGoalStats;
	mainTeam: Team | undefined;
	opponentTeam: Team | undefined;
	label: string;
	tournament: Tournament | undefined;
	className?: string;
}) => {
	const { t } = useTranslation();

	return (
		<div className={classNames("table--responsive", className)}>
			<table className="table table--framed table--goald">
				<thead className="table__head">
					<tr className="table__head__row table__row">
						<th
							colSpan={4}
							className="table__head__cell table__cell table__cell--xtny u-type--left u-type--wgt--regular"
						>
							<TeamIcon
								showCountryFlag={tournament?.showCountryFlag}
								flagCode={mainTeam?.countryCode}
								jerseyTypeAbrv={mainTeam?.jerseyTypeAbrv}
								opponentFlagCode={opponentTeam?.countryCode}
								opponentJerseyTypeAbrv={opponentTeam?.jerseyTypeAbrv}
								className="u-icon u-icon--base u-mar--right--xtny"
							/>
							<span className="u-align--v--middle">{label}</span>
						</th>
						<th
							colSpan={4}
							className="table__head__cell table__cell table__cell--xtny u-type--right u-type--wgt--regular u-color--text--secondary"
						>
							<span>
								{t(
									`EVENT.STATISTICS.GOAL_DISTRIBUTION.MATCHES_PLAYED`
								)}
								:
							</span>
							<span className="u-mar--left--xtny">
								{teamData.matches}
							</span>
						</th>
					</tr>

					<tr className="table__head__row table__row u-color--text--tertiary">
						<th
							colSpan={2}
							className="table__head__cell table__cell table__cell--xtny u-type--center"
						>
							&nbsp;
						</th>

						{teamData.periods.map((period, index) => {
							const adjustedPeriodStart =
								period.periodStart === 1
									? 0
									: period.periodStart === 46
										? 45
										: period.periodStart;

							return (
								<th
									key={index}
									className="table__head__cell table__cell table__cell--xtny table__cell--w--goald u-type--center"
								>
									<div className="tag--goald tag--goald--period">
										<div>{adjustedPeriodStart}'</div>
										<div>-</div>
										<div>{period.periodEnd}'</div>
									</div>
								</th>
							);
						})}
					</tr>
				</thead>

				<tbody className="table__body">
					<TeamStats
						teamData={teamData}
						label={t("EVENT.STATISTICS.BETTING_TYPE_STATS.SCORED")}
						type="Scored"
					/>
					<TeamStats
						teamData={teamData}
						label={t(
							"EVENT.STATISTICS.BETTING_TYPE_STATS.CONCEDED"
						)}
						type="Conceded"
					/>
				</tbody>
			</table>
		</div>
	);
};
